import Icon from "./Basic/Icon";
import Button from "./Basic/Button";
import kTest from "./Basic/kTest";
import { Row, Col } from "./Layout/Grid";
import Divider from "./Layout/Divider";
import Input from "./Form/Input";
import Switch from "./Form/Switch";
import Slider from "./Form/Slider";
import { Select, Option } from "./Form/Select";
import Message from "./Notice/Message";

const components = {
  kTest: kTest,
  kIcon: Icon,
  kButton: Button,
  kButtonGroup: Button.Group,
  kRow: Row,
  kCol: Col,
  kDivider: Divider,
  kInput: Input,
  kSwitch: Switch,
  kSlider: Slider,
  kSelect: Select,
  kOption: Option,
  Message: Message
};

export default Vue => {
  Object.keys(components).forEach(key => {
    Vue.component(key, components[key]);
  });
  Vue.prototype.$Message = Message;
};
